"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
export default function QueryProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [client] = useState(_temp);
  let t1;
  if ($[0] !== children || $[1] !== client) {
    t1 = <QueryClientProvider client={client}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = client;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60000,
        gcTime: 300000,
        refetchOnWindowFocus: false,
        retry: 2
      },
      mutations: {
        retry: 0
      }
    }
  });
}